import React, { useEffect, useRef, useState } from "react";
import "../Styles/ResetTenantDropdown.css";

const ResetTenantDropdown = ({ options = [], value, onChange, disabled = false }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleClick = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  const selected = options.find((o) => o.value === value) || null;

  const cleanUrl = (u = "") => u.replace(/^https?:\/\//, "");

  // booked => SHARED (as per your second image)
  const normType = (type = "") => {
    const t = String(type).toLowerCase();
    if (t === "booked" || t === "shared") return "shared";
    return "personal";
  };

  const badgeLabel = (type = "") => (normType(type) === "shared" ? "SHARED" : "PERSONAL");

  const badgeClass = (type = "") =>
    normType(type) === "shared"
      ? "reset-tenant-dd-badge reset-tenant-dd-badge--shared"
      : "reset-tenant-dd-badge reset-tenant-dd-badge--personal";

  const dotClass = (type = "") =>
    normType(type) === "shared"
      ? "reset-tenant-dd-dot is-shared"
      : "reset-tenant-dd-dot is-personal";

  const handleSelect = (opt) => {
    onChange?.(opt.value);
    setOpen(false);
  };

  return (
    <div className={`reset-tenant-dd ${disabled ? "is-disabled" : ""}`} ref={wrapperRef}>
      <button
        type="button"
        className="reset-tenant-dd-trigger"
        onClick={() => !disabled && setOpen((s) => !s)}
      >
        {/* LEFT: dot + url (always left aligned) */}
        <div className="reset-tenant-dd-left">
          <span className={dotClass(selected?.type)} />
          <span className={`reset-tenant-dd-url ${!selected ? "is-placeholder" : ""}`}>
            {selected ? cleanUrl(selected.displayUrl) : "Select a Tenant"}
          </span>
        </div>

        {/* RIGHT: badge + chevron pinned to the right */}
        <div className="reset-tenant-dd-right">
          {selected && <span className={badgeClass(selected.type)}>{badgeLabel(selected.type)}</span>}
          <span className={`reset-tenant-dd-chevron ${open ? "is-open" : ""}`} />
        </div>
      </button>

      {open && !disabled && (
        <div className="reset-tenant-dd-menu">
          {options.length === 0 ? (
            <div className="reset-tenant-dd-empty">No tenants available</div>
          ) : (
            options.map((opt) => {
              const active = opt.value === value;
              return (
                <button
                  key={opt.value}
                  type="button"
                  className={`reset-tenant-dd-option ${active ? "is-active" : ""}`}
                  onClick={() => handleSelect(opt)}
                >
                  <div className="reset-tenant-dd-option-left">
                    <span className={dotClass(opt.type)} />
                    <span className="reset-tenant-dd-url">{cleanUrl(opt.displayUrl)}</span>
                  </div>

                  <span className={badgeClass(opt.type)}>{badgeLabel(opt.type)}</span>
                </button>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

export default ResetTenantDropdown;
